export default "__VITE_ASSET__BUNPDMmJ__"